import { render } from "./RegistrySecondaryTitle.vue?vue&type=template&id=02118fcf"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "02118fcf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('02118fcf', script)) {
    api.reload('02118fcf', script)
  }
  
  module.hot.accept("./RegistrySecondaryTitle.vue?vue&type=template&id=02118fcf", () => {
    api.rerender('02118fcf', render)
  })

}

script.__file = "src/views/services/pageTitles/RegistrySecondaryTitle.vue"

export default script